<template>
  <div>
    <img
      :src="imgSrc"
      alt=""
      class="rounded-lg shadow-lg object-cover object-center  w-full  lg:static lg:h-auto"
    />
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "RichTextImage",
  props: {
    _sanityProps: {
      type: Object
    },
    image: {
      type: Object
    }
  },
  computed: {
    imgSrc() {
      return sanityImageBuilder
        .image(this._sanityProps.node)
        .width(700)
        .url();
    }
  }
};
</script>

<style scoped></style>
